<mat-sidenav-container style="min-height: 90vh;">
  <!-- Main Grid -->
  <mat-sidenav-content>
    <ion-row class="p-0 mb-5 mt-10 ml-10" *ngIf="gridData.tabsData.length!=0">
      <ion-col size-sm="12" size-md="12" size-lg="12" size-xs="12" class="p-0">
        <div class="borderbottomForTab">
          <mat-tab-group [selectedIndex]="selectedTypeTabIndex" (selectedTabChange)="tabTypeChanged($event)">
            <mat-tab *ngFor="let item of gridData.tabsData">
              <ng-template mat-tab-label>
                <span style="display: contents;" *ngIf="item.label != 'Change Password'">
                  <span class="material-icons mr-10">{{item.icons}}</span>
                  {{item.label}} ({{item.totalCount}})
                </span>
                <span style="display: contents;" *ngIf="item.label == 'Change Password'">
                  <span class="material-icons mr-10">{{item.icons}}</span>
                  {{item.label}}
                </span>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="p-0 mb-10 ion-align-items-center ion-justify-content-between ml-10">
      <!-- LEFT SECTION -->
      <ion-col size="auto">
        <div class="verticle-center d-flex ion-align-items-center">
          <img *ngIf="gridData.showBackBtn" src="./assets/icon/backArrow.svg" class="cp mr-10" (click)="backBtn()" />

          <ion-label class="font_bold fs-16 fs_14ForMobile black_color" *ngIf="gridData?.showTitle">{{TableName}} ({{gridData.totalCount}})</ion-label>
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="p-0 mb-10 ion-align-items-center ion-justify-content-between ml-10">
      <!-- LEFT SECTION -->
      <ion-col size="auto">
        <div class="verticle-center d-flex ion-align-items-center">
          <!-- Search Box (LEFT side of right section) -->
          <mat-form-field class="mat-height40 mat-input-style mr-10">
            <mat-icon matPrefix>search</mat-icon>
            <input matInput type="search" placeholder="Search" [(ngModel)]="searchText" (input)="onSearch()" />
          </mat-form-field>

          <ion-label class="font_bold black_color ml-10" *ngIf="gridData?.showBreadCrumbs">
            <span class="cp fs_14ForMobile">Configuration</span>
            &nbsp;>&nbsp;
            <span class="cp">UA/UC Configuration</span>
            &nbsp;>&nbsp;
            <span [style.color]="buttonColorName">234</span>
          </ion-label>
        </div>
      </ion-col>

      <!-- RIGHT SECTION -->
      <ion-col size="auto">
        <div class="ion-align-items-center">
          <!-- Buttons (RIGHT side) -->
          <div class="phi-flex-wrap-center phi-gap-6 emp-master-eia-btns">
            <span class="ml-5 fs-20 material-icons btn-reset" style="cursor:pointer;" [class.clicked]="isClicked" (click)="resetGrid(); isClicked = true" (animationend)="isClicked = false">refresh</span>
            <button *ngIf="gridData?.showExportBtn" type="button" class="exportToExcel_btn fs-14 fs_12ForMobile font_medium">
              <span class="d-inline-flex ion-align-items-center" (click)="exportReport()">
                <img class="mr-5" src="././assets/icon/exportIcon.svg" />
                Export
              </span>
            </button>
            <button *ngIf="gridData?.showImportBtn " type="button" class="import_btn fs-14 fs_12ForMobile">
              <span class="d-inline-flex ion-align-items-center" (click)="importReport()">
                <img class="mr-5" src="././assets/icon/importIcon.svg" />
                Import
              </span>
            </button>
            <button *ngIf="gridData?.showAddBtn " type="button" class="add_btn fs-14 fs_12ForMobile" [style.background-color]="buttonColorName" (click)="addRecord()">+ Add New</button>
          </div>
        </div>
      </ion-col>
    </ion-row>

    <ion-row class="p-0 mb-10 verticle-center dfadsfasdfadfasd ml-20">
      <label *ngIf="mulipleSelect.length>0 || selectAllCheckbox" class="verticle-center">
        <button class="delete_btn fs-14 fs_12ForMobile font_semibold verticle-center" *ngIf="(gridData.showPermantDeleteBtn || gridData.showDeleteBtn) && isPerDeleteFlag" (click)="deleteMultipleRecords()">
          <span class="material-icons mr-5">delete</span>
          Delete
        </button>
      </label>
    </ion-row>

    <!-- AG Grid -->
    <div style="margin: 20px;">
      <!-- Outer space -->
      <ag-grid-angular style="width: 100%; height: 500px;" class="ag-theme-quartz responsive-page-bar" [rowData]="gridData?.columnData" [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" [pagination]="true" [paginationPageSize]="paginationPageSize" [paginationPageSizeSelector]="paginationPageSizeSelector" (gridReady)="onGridReady($event)" (cellClicked)="onRowClickedForEmployee($event)" [getRowClass]="getRowClass" (selectionChanged)="onSelectionChanged()" rowSelection="multiple" [suppressRowClickSelection]="true"></ag-grid-angular>
    </div>
  </mat-sidenav-content>

  <!-- Right Side Sidenav -->
  <!-- <mat-sidenav 
  #detailsPanel 
  mode="over" 
  position="end" 
  [(opened)]="isDetailsOpen" 
  class="details-panel">


  <div class="details-header">
    <h2>Employee Details</h2>
    <button mat-icon-button (click)="isDetailsOpen=false">
      <mat-icon class="close-icon">close</mat-icon>
    </button>
  </div>


  <div class="details-content" *ngIf="selectedRow">
    <mat-card class="detail-card" *ngFor="let col of gridData?.columnInfo">
      <mat-card-content>
        <div class="detail-row d-flex align-items-center justify-content-start">
          <span class="detail-label mr-10">{{ col.label }}</span>
          <mat-icon class="detail-icon mr-10">trending_flat</mat-icon>

          <ng-container *ngIf="col.label === 'Action'; else normalContent">
            <div class="d-flex align-items-center">
              <mat-icon class="cp mr-10" style="color:#ff9800;" (click)="editDetail(selectedRow)">edit</mat-icon>
              <mat-icon class="cp" style="color:#e53935;" (click)="LoginDetail(selectedRow)">login</mat-icon>
            </div>
          </ng-container>

          <ng-template #normalContent>
            <span>{{ selectedRow[col.propertyName] }}</span>
          </ng-template>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</mat-sidenav> -->

  <mat-sidenav #detailsPanel mode="over" position="end" [(opened)]="isDetailsOpen" class="details-panel">
    <!-- HEADER -->
    <div class="details-header">
      <h2>Employee Data</h2>
      <button mat-icon-button (click)="closeDetails()">
        <mat-icon class="close-icon">close</mat-icon>
      </button>
    </div>

    <!-- CONTENT -->
    <div class="details-content" *ngIf="selectedRow">
      <mat-card class="detail-card" *ngFor="let col of gridData?.columnInfo">
        <mat-card-content>
          <div class="detail-row">
            <mat-icon class="detail-icon">trending_flat</mat-icon>
            <div class="detail-text">
              <!-- LABEL -->
              <span class="detail-label">{{ col.label }}</span>

              <!-- ACTION BUTTONS with condition -->
              <ng-container *ngIf="col.label === 'Action'; else normalContent">
                <div class="d-flex align-items-center">
                  <!-- <mat-icon class="cp mr-10" style="color:#ff9800;" (click)="editDetail(selectedRow)">edit</mat-icon>
                  <mat-icon class="cp" style="color:#e53935;" (click)="LoginDetail(selectedRow)">login</mat-icon> -->
                  <img class="edit-btn" class="mr-5 cp imgdelete" src="././assets/icon/edit.png" (click)="editDetail(selectedRow)" style="width:20px;margin-top:10px" />
                  <img class="user-btn" class="mr-5 cp imgdelete" src="././assets/icon/user-login.png" (click)="LoginDetail(selectedRow)" style="width:20px;margin-top:10px" />
                </div>
              </ng-container>

              <ng-template #normalContent>
                <span>{{ selectedRow[col.propertyName] }}</span>
              </ng-template>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </mat-sidenav>
</mat-sidenav-container>
